import { render } from "./MyHomeButton.vue?vue&type=template&id=4bb71442&scoped=true"
import script from "./MyHomeButton.vue?vue&type=script&lang=js"
export * from "./MyHomeButton.vue?vue&type=script&lang=js"

import "./MyHomeButton.vue?vue&type=style&index=0&id=4bb71442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb71442"]])

export default __exports__